export default __webpack_public_path__ + "static/media/KOD0040-min.2afc6cc7.webp";